export default __webpack_public_path__ + "static/media/contact-us.ac9ddf4a.jpg";